module.exports = __webpack_public_path__ + "img/PINSMedical.fd363263.jpg";